import {
  Box,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import React, { useState } from "react";
import {
  blackColor,
  blackShade05,
  blackShade19,
  blackShade21,
  blueColor04,
  border25,
  borderTextBoxColor,
  copyBtnColor,
  greyColor40,
  greyColor42,
  greyColor47,
  mobilePrimary,
  outOfStockColor,
  whiteColor,
  yellowShade01,
  yellowShade02,
  yellowShade03,
} from "../../../configs/styles/muiThemes";
import { textOneLines, textTwoLines } from "../../../utils/styles";
import { toTitleCase } from "../../../utils/validationUtils";
import { getVariantValues } from "../../../utils/validateAndPrepareVariant";
import ModalCard from "../../../components/ModalCard";
import ThreeDotLoader from "../../../components/ThreeDotLoader";

function VariantInventoryCard({
  img,
  originalAmt,
  amt,
  priceOff,
  ondcEnabled,
  productName,
  onMainProductClick,
  count,
  loader,
  childProducts,
  tableHeader,
  showChild,
}) {
  const [showMore, setShowMore] = useState(null);

  return (
    <Box sx={{ borderBottom: border25, p: "10px" }}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
        onClick={onMainProductClick}
      >
        <Box flex={0.9} display="flex" gap={1} sx={{ cursor: "pointer" }}>
          <Box component="img" src={img} sx={styles.imgContainer} />
          <Stack gap={0.5}>
            <Typography
              fontSize={{ xs: 13, md: 12.5 }}
              color={blackColor}
              fontWeight={{ xs: 600, md: 500 }}
              lineHeight={1.5}
              mb="0px !important"
              sx={{ ...textOneLines }}
            >
              {productName}
            </Typography>
            <Box
              display="flex"
              alignItems="center"
              columnGap={1}
              rowGap={0.5}
              flexWrap={"wrap"}
            >
              <Typography
                fontSize={11}
                color={blackShade21}
                sx={{
                  textDecoration: "line-through",
                }}
              >
                ₹ {originalAmt || "100"}
              </Typography>

              <Typography fontSize={12} fontWeight={600} color={blueColor04}>
                ₹ {amt || "100"}
              </Typography>

              <Box sx={styles.percentageOffTag}>{priceOff || "5"} %</Box>

              <Typography fontSize={11.5} fontWeight={400} color={greyColor40}>
                ONDC Enabled :{" "}
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: ondcEnabled ? copyBtnColor : outOfStockColor,
                  }}
                >
                  {/* {toTitleCase(ondcEnabled || "No")} */}
                  {ondcEnabled ? "Yes" : "No"}
                </span>
              </Typography>
            </Box>
            <Box display={"flex"} gap={1}>
              <Typography fontSize={11.5} fontWeight={400} color={greyColor40}>
                No of Variants
              </Typography>
              <Typography fontSize={12} color={blackShade19} fontWeight={500}>
                {count}
              </Typography>
            </Box>
          </Stack>
        </Box>
        <Box flex={0.1}>
          {showChild ? (
            <ExpandLessRoundedIcon
              sx={{ color: mobilePrimary, fontSize: "26px" }}
            />
          ) : (
            <ExpandMoreRoundedIcon
              sx={{ color: mobilePrimary, fontSize: "26px" }}
            />
          )}
        </Box>
      </Box>
      {showChild ? (
        loader ? (
          <ThreeDotLoader />
        ) : (
          <Box sx={styles.tableWrapper}>
            <TableContainer sx={styles.tableContainer} component={Box}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow
                    sx={{
                      position: "sticky !important",
                      top: 0,
                      backgroundColor: greyColor42,
                      zIndex: 20,
                      borderRadius: "8px 8px 0 0",
                    }}
                  >
                    {tableHeader?.map((item, index) => {
                      return (
                        <TableCell key={item.id} sx={styles.tableCell}>
                          <Box
                            display={index === 0 ? "flex" : "inline-block"}
                            alignItems="center"
                            gap={1.2}
                          >
                            <Box
                              sx={{ fontSize: 12, textTransform: "uppercase" }}
                            >
                              {item?.title}
                            </Box>
                          </Box>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody sx={{ backgroundColor: whiteColor }}>
                  {childProducts?.map((product, index) => {
                    const data = getVariantValues(product);

                    return (
                      <TableRow
                        key={index}
                        sx={{
                          borderBottom: `1px solid ${borderTextBoxColor}`,
                          verticalAlign: "top",
                        }}
                      >
                        <TableCell sx={styles.tableBodyCell}>
                          <TableInputPreview
                            data={toTitleCase(data?.variant1)}
                          />
                        </TableCell>
                        {data?.variant2 && (
                          <TableCell sx={styles.tableBodyCell}>
                            <TableInputPreview
                              data={toTitleCase(data?.variant2)}
                            />
                          </TableCell>
                        )}
                        {data?.variant3 && (
                          <TableCell sx={styles.tableBodyCell}>
                            <TableInputPreview
                              data={toTitleCase(data?.variant3)}
                            />
                          </TableCell>
                        )}
                        <TableCell sx={styles.tableBodyCell}>
                          <Box
                            component="img"
                            src={product?.productPhoto?.[0]?.docURL}
                            sx={styles.childImgContainer}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )
      ) : null}

      <ModalCard open={showMore} handleClose={() => setShowMore(false)}>
        <Box
          sx={{
            backgroundColor: whiteColor,
            py: 3,
            px: 2,
            borderRadius: "10px",
          }}
        >
          <Typography fontSize={12.5} color={blackShade19} fontWeight={500}>
            Variants update is currently available only on our browser web
            version.
          </Typography>
          <Typography
            fontSize={12.5}
            color={blackShade19}
            fontWeight={500}
            mt={1}
          >
            For the best experience and to use this feature, please switch to a
            desktop or laptop computer and access our site through a standard
            web browser.
          </Typography>
        </Box>
      </ModalCard>
    </Box>
  );
}

export default VariantInventoryCard;

const TableInputPreview = ({ data }) => {
  return (
    <Typography
      variant="body1"
      title={data}
      sx={{ ...styles.prodNameBox, ...textOneLines }}
    >
      {data || "-"}
    </Typography>
  );
};

const styles = {
  imgContainer: {
    width: "40px",
    height: "40px",
    borderRadius: "6px",
    border: border25,
    backgroundColor: whiteColor,
  },
  childImgContainer: {
    width: "36px",
    height: "36px",
    borderRadius: "6px",
    border: border25,
    backgroundColor: whiteColor,
  },
  percentageOffTag: {
    fontSize: 11,
    fontWeight: 600,
    color: yellowShade01,
    bgcolor: yellowShade02,
    border: "1px solid" + yellowShade03,
    p: "0px 5px",
    borderRadius: "4px",
  },
  tableWrapper: {
    width: { md: "calc(100vw - 310px)", xs: "100%" },
    borderRadius: "8px",
    border: `1px solid ${borderTextBoxColor}`,
  },
  tableContainer: {
    borderRadius: "8px",
    overflow: "scroll",
    maxHeight: "calc(100vh - 370px)",
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },
  tableCell: {
    color: greyColor47,
    fontSize: "12.5px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor42,
    borderRight: `1px solid ${whiteColor}`,
    // ":last-child": { position: "sticky", right: "-3px" },
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset `,
  },
  tableBodyCell: {
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "8px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,
  },
  prodNameBox: {
    whiteSpace: "normal",
    fontSize: 12,
    fontWeight: 500,
    color: blackShade19,
    lineHeight: "16px",
  },
  moreLink: {
    whiteSpace: "normal",
    fontSize: 12,
    fontWeight: 500,
    color: mobilePrimary,
    lineHeight: "16px",
    cursor: "pointer",
    textDecoration: "underline",
  },
  tableStickyRightCell: {
    position: "sticky",
    right: 0,
    zIndex: 12,
    boxShadow: `1px 0 0 0 ${borderTextBoxColor} inset`,
    backgroundColor: whiteColor,
    whiteSpace: "nowrap",
    color: blackShade05,
    padding: "8px 15px !important",
  },
};
